import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const ConfigurationsSubForm = loadable(() =>
  withDefaultLoaderModifiers(import("./ConfigurationsSubForm"))
);
